import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { PeriodFilter$reflection, ContractTypeFilter$reflection } from "../../Api/DataSet.js";
import { empty as empty_1, ofSeq } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { comparePrimitives } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { toFail, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { match } from "../../fable_modules/fable-library.3.7.20/RegExp.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Reports", "SpecificReport", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Reports.Model.Page", [], Page, () => [[], [["Item", string_type]], []]);
}

export class Filter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ContractType", "PeriodFrom", "PeriodTo"];
    }
}

export function Filter$reflection() {
    return union_type("Containers.Reports.Model.Filter", [], Filter, () => [[["Item", ContractTypeFilter$reflection()]], [["Item", PeriodFilter$reflection()]], [["Item", PeriodFilter$reflection()]]]);
}

export const contractTypeFilterId = "contractTypeFilter";

export const periodFromFilterId = "periodFromFilter";

export const periodToFilterId = "periodToFilter";

export const hardCodedFilterParamNames = ofSeq([contractTypeFilterId, periodFromFilterId, periodToFilterId], {
    Compare: comparePrimitives,
});

export function getActiveFilterParamNames(filtersOpt) {
    if (filtersOpt != null) {
        const filters = filtersOpt;
        return ofSeq(toList(delay(() => append(filters.ContractType.IsActive ? singleton(contractTypeFilterId) : empty(), delay(() => append(filters.PeriodFrom.IsActive ? singleton(periodFromFilterId) : empty(), delay(() => (filters.PeriodTo.IsActive ? singleton(periodToFilterId) : empty()))))))), {
            Compare: comparePrimitives,
        });
    }
    else {
        return empty_1({
            Compare: comparePrimitives,
        });
    }
}

export function getTranslationStr(getTranslationFn, setId, key) {
    return getTranslationFn(toText(printf("%s.%s.%s"))("DataSetTranslation")(setId)(key));
}

export function getChartTitleKey(chartIndex) {
    return toText(printf("Chart%i.Title"))(chartIndex);
}

export function getChartSerieTitleKey(chartIndex, serieIndex) {
    return toText(printf("Chart%i.Series%i.Title"))(chartIndex)(serieIndex);
}

export const allowedDataKeys = ofArray([["y1", "y1"], ["y2", "y2"], ["y3", "y3"], ["y4", "y4"], ["y5", "y5"], ["y6", "y6"]]);

export function getSeriesIndex(dataKey) {
    const regexMatch = match(/(\d+)/gu, dataKey);
    if (regexMatch != null) {
        const seriesIndex = (parse(regexMatch[1] || "", 511, false, 32) - 1) | 0;
        if (seriesIndex < 0) {
            return 0;
        }
        else {
            return seriesIndex | 0;
        }
    }
    else {
        return toFail(printf("[getSeriesIndex] Cannot find serie index from dataKey: \u0027%s\u0027"))(dataKey) | 0;
    }
}

